import React from 'react';
import cn from 'classnames';
import isEqual from 'lodash/isEqual';
import DataTable, { IColumn, dataTableStyles } from '@dealroadshow/uikit-table/DataTable';
import IconAdd from '@dealroadshow/uikit-icon/IconAdd';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';

import DialInCountriesTableContext, {
  useDialInCountriesTableContext,
  IProps as IDialInCountriesTableContextProps,
} from './DialInCountriesTableContext';
import { useCallFormContext } from '../CallFormContext';

import { IDialInCountryTableRowItem } from './interfaces';

import { DIAL_IN_COUNTRY_FOR_OPTIONS } from './constants';
import { DIAL_IN_COUNTRIES_TABLE_COLUMNS_BY_INSTANCE } from './columns';

import styles from './dialInCountriesTable.module.scss';

interface IProps {
  containerCls?: string,
}

const DialInCountriesTable = (
  {
    containerCls,
  }: IProps,
) => {
  const {
    fields,
    disabled,
    countryOptions,
  } = useDialInCountriesTableContext();

  const { instance, isDmPortal } = useCallFormContext();

  const tableData = fields.map<IDialInCountryTableRowItem>((fieldName, fieldIndex) => (
    {
      fieldName,
      fieldIndex,
      className: styles.tableRow,
      isDragAndDropDisabled: fieldIndex === 0,
      ...fields.value[fieldIndex],
    }
  ));

  const orderCallback = (oldIndex, newIndex) => {
    if (newIndex !== 0) {
      fields.move(oldIndex, newIndex);
    }
  };

  return (
    <div className={ cn(styles.countriesTableContainer, containerCls) }>
      <DataTable
        dataTest="dialInCountriesTable"
        className={ dataTableStyles.isSecondaryTable }
        isDraggable={ isDmPortal }
        data={ tableData }
        columns={ DIAL_IN_COUNTRIES_TABLE_COLUMNS_BY_INSTANCE[instance] as IColumn[] }
        orderCallback={ orderCallback }
      />
      <Button
        variant={ ButtonVariantType.text }
        dataTest="dialInCountryAddButton"
        className={ styles.addItemButton }
        disabled={ disabled || isEqual(fields.length, countryOptions.length) }
        onClick={ () => fields.push(
          {
            countryId: null,
            countryFor: DIAL_IN_COUNTRY_FOR_OPTIONS.SPEAKERS_AND_PARTICIPANTS,
            countryDisplay: !!isDmPortal,
          },
        ) }
      >
        <IconAdd className={ styles.addItemIcon } />
        Add Dial-In
      </Button>
    </div>
  );
};

export default ({ containerCls, ...props }: IDialInCountriesTableContextProps & IProps) => (
  <DialInCountriesTableContext { ...props }>
    <DialInCountriesTable containerCls={ containerCls } />
  </DialInCountriesTableContext>
);
